// extracted by mini-css-extract-plugin
module.exports = {"welcomeLayoutLeftBar":"forgotPassword_welcomeLayoutLeftBar__Pfhsr","loginRightInn":"forgotPassword_loginRightInn__2LWPz","dontHaveAccount":"forgotPassword_dontHaveAccount__3QKqp"};